// Below is babel generated output for the function. This is necessary so IE11 does not throw an error.
// Original script:
// window.bootstrapDetectBreakpoint = function() {
//     const breakpointNames = ["xl", "lg", "md", "sm", "xs"]
//     let breakpointValues = []
//     for (const breakpointName of breakpointNames) {
//         breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + breakpointName)
//     }
//     let i = breakpointNames.length
//     for (const breakpointName of breakpointNames) {
//         i--
//         if (window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")").matches) {
//             return breakpointName;
//         }
//     }
//     return null;
// }
// Transformation link: https://babeljs.io/repl/#?browsers=&build=&builtIns=false&spec=false&loose=false&code_lz=O4SwdgJg9sB0BGUoBcDOyBOBDADgEQFNkCBjZAIQwKwGscpxkACAXiYDMBXMMkKMABQBKJgG8AUEylMS_dE3hVa9RgDksAWwKpWTANoAiAB4AbAwBomBkwHMLVjRHsHUG50dQGAupOkmiCkp0DGDIAGpYJpzauno-0hxQGEwCsmDyitTBapoETFDsgVkqoepaqCISCQmZyiHhkdGoerXZpbleuqCQMLA2RADCUBo4nMQQAMrIAJ7-AtAknFqhsAtLBKEAov7LyEJ9RAAKGFA4BBgzEVEEAgDkALT3rSXI97dMANRFdTlaQr5SAC-AKY_mYIF0z3qZW0sH8YBsyAAFiD2EkUmkMkEXjD8oUob9tJUQQkQI8SdIQIUBN1oHANFhkCQkQBZAgQEBYAQGAQacD3UAQZEALisn2-bQa12aBPaWk6XwMQiVsAZTKRRLEFOqTCoyE4GDAEpxuQA3NqmMCElbpHqDUawJwTCZzYCgA&debug=false&forceAllTransforms=false&shippedProposals=false&circleciRepo=&evaluate=false&fileSize=false&timeTravel=false&sourceType=module&lineWrap=true&presets=es2015%2Creact%2Cstage-2&prettier=false&targets=&version=7.12.12&externalPlugins=
window.bootstrapDetectBreakpoint = function () {
    var breakpointNames = ["xl", "lg", "md", "sm", "xs"];
    var breakpointValues = [];

    for (var _i = 0, _breakpointNames = breakpointNames; _i < _breakpointNames.length; _i++) {
      var breakpointName = _breakpointNames[_i];
      breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + breakpointName);
    }

    var i = breakpointNames.length;

    for (var _i2 = 0, _breakpointNames2 = breakpointNames; _i2 < _breakpointNames2.length; _i2++) {
      var _breakpointName = _breakpointNames2[_i2];
      i--;

      if (window.matchMedia("(min-width: " + breakpointValues[_breakpointName] + ")").matches) {
        return _breakpointName;
      }
    }

    return null;
  };

window.ctIsScreenDesktop = function() {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (isIE11) {
        return window.matchMedia("(min-width: 992px)").matches;
    }

    let screenSize = bootstrapDetectBreakpoint();
    return (screenSize === "xl" || screenSize === "lg");
}

jQuery(window).on("load", function() {

    if (ctIsScreenDesktop()) {
        jQuery(".ct-container-home").each(function (index, element) {
            // Equalize the height of all images
            let maxHeightImg = 0;
            jQuery(".ct-iconlist-img", jQuery(element)).each(function (idx, img) {
                maxHeightImg = Math.max(maxHeightImg, jQuery(img).height());
            });
            jQuery(".ct-iconlist-img", jQuery(element)).height(maxHeightImg + "px");
            // Center vertical images (only after height calculation, because of "absolute" position)
            jQuery(".ct-iconlist-img img", jQuery(element)).addClass("ct-iconlist-img-centered");

            // Equalize the height of all titles
            let maxHeightTitle = 0;
            jQuery(".ct-iconlist-title", jQuery(element)).each(function (idx, text) {
                maxHeightTitle = Math.max(maxHeightTitle, jQuery(text).height());
            });
            jQuery(".ct-iconlist-title", jQuery(element)).height(maxHeightTitle + "px");
        });
    }

});
